import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { House, Ticket, ClockCounterClockwise, SignOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/customer/home", label: "Ana Sayfa", icon: House },
  { to: "/customer/coupons", label: "Kuponlar", icon: Ticket },
  { to: "/customer/history", label: "Geçmiş", icon: ClockCounterClockwise },
];

export default function CustomerLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const onLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <div className="min-h-screen bg-background pb-20">
      <header className="sticky top-0 z-30 bg-card border-b border-border">
        <div className="px-4 py-3 flex items-center justify-between max-w-2xl mx-auto">
          <div>
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Müşteri</div>
            <div className="font-bold" data-testid="customer-user-name">{user?.name}</div>
          </div>
          <div className="flex items-center gap-2">
            {user?.plate && (
              <span className="tr-plate text-sm" data-testid="customer-plate">{user.plate}</span>
            )}
            <Button variant="ghost" size="icon" onClick={onLogout} data-testid="customer-logout">
              <SignOut size={18} />
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-6">{children}</main>

      <nav className="fixed bottom-0 left-0 right-0 z-40 bg-card border-t border-border">
        <div className="max-w-2xl mx-auto flex">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={`cust-nav-${to.split("/").pop()}`}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center gap-1 px-4 py-3 text-xs font-medium ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`
              }
            >
              <Icon size={22} />
              <span>{label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
